import Box from '@mui/material/Box';
import { PulseLoader } from 'react-spinners';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import Divider from '@mui/material/Divider';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getAttributedOrders, getIsOrdersLoading, getOrderCounts } from '../../../../store/orders/selectors';
import { usePermissions } from '../../../../hooks/useCommon';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';

type TOrdersCountLoader = {
  pt?: number,
  px?: number
  pb?: number
  isDisplayDivider?: boolean
};

const OrdersCountLoader: FC<TOrdersCountLoader> = ({
  pt = 2, px = 3, pb = 0, isDisplayDivider = true,
}) => {
  const totalOrders = useAppSelector(getOrderCounts);
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const { t } = useTranslation(['commissions', 'timesheets', 'inputs']);
  const isOrdersLoading = useAppSelector(getIsOrdersLoading);
  const { permissions } = usePermissions();
  const attributedOrders = useAppSelector(getAttributedOrders);
  const { personnel } = useAppSelector(getAuthenticateUser);

  return (
    totalOrders > 0 && (
      <>
        {isDisplayDivider && <Divider sx={{ borderStyle: 'dashed' }} />}
        <Box display="flex" pb={pb} justifyContent="flex-end" pt={pt} px={isMobile ? 0 : px} alignItems="center">
          {isOrdersLoading && <PulseLoader color="rgb(16 185 129 / 1)" size={8} />}
          <Typography pl={2} color="rgb(16 185 129 / 1)">
            {permissions.isAdmin ? `${attributedOrders?.length || 0} ${t('of')} ${isOrdersLoading ? totalOrders : attributedOrders?.length || 0} ${t('ordersLoadedSuccessfully')}`
              : `${t('loaded', { ns: 'orders' })} ${attributedOrders?.length || 0} ${t('orders', { ns: 'timesheets' })} ${t('from', { ns: 'inputs' })} ${personnel.locations?.length} ${t('locations', { ns: 'inputs' })}`}
          </Typography>
        </Box>
      </>
    )
  );
};

export { OrdersCountLoader };
